import { twMerge } from "tailwind-merge";

interface SubmitButtonProps {
  loading: boolean;
  text: string;
  loadingText: string;
  onClick: (e: React.FormEvent) => void;
  className?: string;
  disabled?: boolean;
  icon?: React.ReactNode;
}

const SubmitButton = ({ loading, loadingText, text, onClick, className = "", disabled = false, icon = null }: SubmitButtonProps) => {
  const isDisabled = loading || disabled;

  return (
    <button
      type="submit"
      disabled={isDisabled}
      className={twMerge("w-full bg-brand-600 hover:bg-brand-700 disabled:bg-gray-400 disabled:cursor-not-allowed text-white font-medium py-3 px-4 rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2", className)}
      onClick={onClick}
    >
      {loading ? loadingText : <span className="flex items-center justify-center gap-2">{icon && icon}{text}</span>}
    </button>
  );
};

export default SubmitButton;
